import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Star } from "lucide-react";
import { getTopTestimonials } from "@/lib/testimonials";

export function ReviewsBanner() {
  const top = getTopTestimonials(5);
  const [i, setI] = useState(0);

  useEffect(() => {
    if (top.length <= 1) return;
    const id = setInterval(() => setI((n) => (n + 1) % top.length), 6000);
    return () => clearInterval(id);
  }, [top.length]);

  if (top.length === 0) return null;
  const t = top[i];

  return (
    <section
      aria-label="Client testimonials"
      className="border-y border-hairline bg-foreground text-background"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-4 px-6 py-6 lg:flex-row lg:gap-10 lg:px-12 lg:py-5">
        <div className="flex shrink-0 items-center gap-3">
          <div className="flex" role="img" aria-label={`${t.rating} out of 5 stars`}>
            {Array.from({ length: 5 }).map((_, idx) => (
              <Star
                key={idx}
                className={`h-3.5 w-3.5 ${
                  idx < t.rating ? "fill-background text-background" : "text-background/30"
                }`}
                strokeWidth={1.25}
              />
            ))}
          </div>
          <span className="text-[10px] uppercase tracking-luxe text-background/60">
            From the House
          </span>
        </div>

        <div className="relative flex-1 overflow-hidden text-center lg:text-left">
          <AnimatePresence mode="wait">
            <motion.p
              key={t.id}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
              className="font-serif text-sm font-light italic leading-relaxed lg:text-base"
            >
              &ldquo;{t.quote}&rdquo;
              <span className="ml-3 not-italic text-[10px] uppercase tracking-luxe text-background/60">
               , {t.author}
                {t.detail ? ` · ${t.detail}` : ""}
              </span>
            </motion.p>
          </AnimatePresence>
        </div>

        <div className="hidden shrink-0 items-center gap-1.5 lg:flex">
          {top.map((tt, idx) => (
            <button
              key={tt.id}
              onClick={() => setI(idx)}
              aria-label={`Show review ${idx + 1}`}
              className={`h-1 w-6 transition-colors ${
                idx === i ? "bg-background" : "bg-background/25"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
